/* eslint-disable no-undefined */
import { differenceInCalendarDays, formatSimpleDate } from "../date-utils/DateUtils";

var sortDateUsingFilter = function sortDateUsingFilter(dialogues) {
  var currentdate = formatSimpleDate(new Date(2007, 0, 29), {
    pattern: "MM-DD-YYYY"
  });
  dialogues.map(function (item, key) {
    var rdataDate = formatSimpleDate(item.created, {
      pattern: "dddd, Do MMM YYYY"
    });
    var diff = differenceInCalendarDays(new Date(), item.created);
    var res;

    if (diff < -1) {
      res = "Last Week";
    } else if (diff < 0 || diff === 1) {
      res = "Yesterday";
    } else if (diff < 1) {
      res = "Today";
    } else {
      res = rdataDate;
    }

    if (rdataDate !== currentdate) {
      dialogues[key].dateCaption = res;
      currentdate = rdataDate;
    }
  });
};

export var getLastAmbassadorDialogue = function getLastAmbassadorDialogue(message) {
  sortDateUsingFilter(message.dialogues);
  var expertDialogues = message.dialogues.filter(function (_ref) {
    var origin = _ref.origin;
    return origin === "expert";
  });
  var hasSingleExpert = expertDialogues.length > 0 ? !!expertDialogues.reduce(function (last, curr) {
    return last.userId === curr.userId ? last : NaN;
  }) : false;
  var lastDialogue = expertDialogues.length > 0 ? expertDialogues[expertDialogues.length - 1] : {};
  var expertInfo = message.expertAuthors[lastDialogue.userId];
  var thumbnail = expertInfo ? expertInfo.thumbnail : null;
  return {
    hasSingleExpert: hasSingleExpert,
    lastDialogue: lastDialogue,
    thumbnail: thumbnail
  };
};
export var getLastDialogue = function getLastDialogue(message) {
  var lastDialogue = message.dialogues && message.dialogues.length > 0 ? message.dialogues[message.dialogues.length - 1] : {};
  var isLastDialogueAmbassador = true;

  if (lastDialogue.origin === "customer" || lastDialogue.origin === "system") {
    isLastDialogueAmbassador = false;
  }

  return {
    isLastDialogueAmbassador: isLastDialogueAmbassador,
    lastDialogue: lastDialogue
  };
};